import {
  Box, FormControl, RadioGroup, FormControlLabel, Radio, Card, Grid, Container,
} from '@mui/material';
import styles from './AnimationSetting.module.css';

interface Props {
  animation: string,
  onAnimationChange: (animation: string) => void,
}

export default function AnimationSetting(props: Props) {
  const { animation, onAnimationChange } = props;

  return (
<Box>
        <h3>アニメーション設定</h3>
        <br />
        <h6>ページのスクロール時のブロック表示にアニメーション効果を設定します。</h6>
        <br />
        <hr />
        <h3>アニメーション効果</h3>

        <br />
        <FormControl component="fieldset">
            <RadioGroup
              aria-label="audio"
              defaultValue=""
              onChange={(e) => onAnimationChange(e.target.value)}
              value={animation || ''}
            >
                <FormControlLabel value="" control={<Radio />} label="なし" />
                <FormControlLabel value="fade-in" control={<Radio />} label="フェードイン" />
                <FormControlLabel value="slide-up" control={<Radio />} label="下からスライド" />
                <FormControlLabel value="slide-down" control={<Radio />} label="上からスライド" />
                <FormControlLabel value="zoom-out" control={<Radio />} label="ズームアウト" />
                <FormControlLabel value="zoom-in" control={<Radio />} label="ズームイン" />
            </RadioGroup>
        </FormControl>

        <br />
        <hr />

        <Card sx={{ minWidth: 275 }}>
          <Container sx={{ padding: 10 }}>
            <Grid container justifyContent="center">
              <Grid className={styles.sampleItem.concat(' animation-block-fade-in')} item>
                <Box className={styles.sampleItemText}>フェードイン</Box>
              </Grid>
              <Grid className={styles.sampleItem.concat(' animation-block-slide-up')} item>
                <Box className={styles.sampleItemText}>下からスライド</Box>
              </Grid>
              <Grid className={styles.sampleItem.concat(' animation-block-slide-down')} item>
                <Box className={styles.sampleItemText}>上からスライド</Box>
              </Grid>
              <Grid className={styles.sampleItem.concat(' animation-block-zoom-out')} item>
                <Box className={styles.sampleItemText}>ズームアウト</Box>
              </Grid>
              <Grid className={styles.sampleItem.concat(' animation-block-zoom-in')} item>
                <Box className={styles.sampleItemText}>ズームイン</Box>
              </Grid>
            </Grid>
          </Container>
        </Card>
    </Box>
  );
}
